export default __webpack_public_path__ + "static/media/deloitte-special-use-icon-font.a18adfdd.ttf";